import { ReactNode } from 'react';

export const NodeLi = (children: ReactNode) => (
  <li className="marker:text-primary-600 [&>p]:m-0">{children}</li>
);
